import React from "react"
import { useTranslation } from "react-i18next"

export default () => {
  const { t } = useTranslation()
  return (
    <div className="absolute top-5 left-1/2 -translate-x-1/2 bg-white px-4 py-2 rounded-xl shadow-xl flex items-center gap-2 z-[1000] pointer-events-none">
      <div className="w-5 h-5 border-[3px] border-gray-400 border-t-blue-500 rounded-full animate-spin"></div>
      <span className="text-[#414141] text-base font-medium">{t("info_loading")}</span>
    </div>
  )
}
